import * as c from "./staticGradient.module.scss";
import classNames from "classnames";
import React from "react";

export default function StaticGradient({ gradientWidth = "100vw", height, mask, top, opacity, centerGradient }) {
  return (
    <div
      className={classNames(c.staticgradient, centerGradient && c.centerGradient)}
      style={{
        width: gradientWidth,
        opacity: opacity || "0.3",
        zIndex: -1,
        height: height || "100%",
        position: "absolute",
        overflow: "hidden",
        maxWidth: "100vw",
        pointerEvents: "none",
        top: top || 0,
        mask: mask || "linear-gradient(to bottom, transparent, #000 150px, #000 calc(100% - 150px), transparent)",
        WebkitMask: mask || "linear-gradient(to bottom, transparent, #000 150px, #000 calc(100% - 150px), transparent)",
      }}
    ></div>
  );
}
